import { SessionModel } from '../session/model';
import { catchError, first, map } from 'rxjs/operators';
import { ExtraStructure } from './model';
import { Observable, of } from 'rxjs';
import { ExtraHelperService } from './extra-helper.service';
import { ExtraRepository } from './store';

const getExtra = (
  sessionId: SessionModel['sessionId']
): Observable<ExtraStructure> => {
  ExtraRepository.setLoading(true);
  return ExtraHelperService.fetchExtra(sessionId).pipe(
    first(),
    map((extras) => {
      ExtraRepository.updateExtra(extras);
      ExtraRepository.setLoading(false);
      return extras;
    }),
    catchError(() => {
      ExtraRepository.setLoading(false);
      return of({ hotelExtras: [], roomExtras: {} });
    })
  );
};

const resetCacheFetchExtra = () => ExtraHelperService.resetCacheFetchExtra();

export const ExtraService = { getExtra, resetCacheFetchExtra };
